import createDataContext from './createDataContext';
import baseURL from '../api.js';
import dummyData from '../components/property/testData';

var axios = require('axios');
var qs = require('qs');

var filterBills = (bills, filters) => {
	var result = bills.filter(function (item, i) {
		let cases = [];
		filters.forEach((f) => {
			let flags = [];
			let key = Object.keys(f)[0];
			f[key].forEach((c) => {
				if (item[key] === c) {
					flags.push(true);
				}
			});

			if (flags.includes(true)) {
				cases.push(true);
			} else {
				cases.push(false);
			}
		});

		if (!cases.includes(false)) {
			return true;
		}
	});

	return result;
};

var addToFilters = (filters, payload) => {
	let checkedFilters = filters;

	let keys = [];

	// console.log("PAYLOAD", payload);
	// console.log("FILTERS", filters);

	checkedFilters.forEach((item) => {
		keys.push(Object.getOwnPropertyNames(item)[0]);
	});

	if (checkedFilters.length < 1) {
		checkedFilters.push({ [payload.prop]: [payload.name] });
	} else {
		checkedFilters.forEach((item) => {
			if (keys.includes(payload.prop)) {
				if (Object.getOwnPropertyNames(item)[0] === payload.prop) {
					if (!item[payload.prop].includes(payload.name)) {
						item[payload.prop].push(payload.name);
					} else {
						if (item[payload.prop].length === 1) {
							checkedFilters.splice(
								checkedFilters.indexOf(item),
								1
							);
						} else {
							item = item[payload.prop].splice(
								item[payload.prop].indexOf(payload.name),
								1
							);
						}
					}
				}
			} else {
				keys.push(payload.prop);

				checkedFilters.push({
					[payload.prop]: [payload.name],
				});
			}
		});
	}

	console.log('CHECKED', checkedFilters);

	return checkedFilters;
};

const reducer = (state, action) => {
	switch (action.type) {
		case 'set_tax_bills':
			return {
				...state,
				taxBills: action.payload.invoices,
				tempTaxBills: action.payload.invoices,
				yearFilters: action.payload.yearFilters,
				typeFilters: action.payload.typeFilters,
				statusFilters: action.payload.statusFilters,
				searchText: action.payload.searchText,
				checkedFilters: [],
				page: 0,
				rowsPerPage: 20,
				searchingTaxBills: false,
			};
		case 'clear_tax_bills':
			return {
				...state,
				taxBills: [],
				tempTaxBills: [],
			};
		case 'searching_tax_bills':
			return {
				...state,
				searchingTaxBills: action.payload,
			};
		case 'set_temp_list':
			return {
				...state,
				tempTaxBills: action.payload,
			};
		case 'set_page':
			return {
				...state,
				page: action.payload,
			};
		case 'set_rows_per_page':
			return {
				...state,
				rowsPerPage: action.payload,
			};
		case 'set_view_item_visible':
			return {
				...state,
				viewItemVisible: action.payload,
			};
		case 'clear_invoices':
			return {
				...state,
				taxBills: [],
				tempTaxBills: [],
			};
		case 'set_current_bill':
			return {
				...state,
				taxBill: action.payload,
				loadingReadBill: false,
			};
		case 'set_loading_read_bill':
			return {
				...state,
				loadingReadBill: true,
			};
		case 'set_checked':
			let alteredArray = [...state[action.payload.filter]];

			const name = () => {
				if (action.payload.name === 1) {
					return 'Paid';
				} else if (action.payload.name === 0) {
					return 'Unpaid';
				} else {
					return action.payload.name;
				}
			};

			alteredArray.map((f) => {
				if (f.name === name()) {
					f.checked = !f.checked;
				}
			});

			let checkedFilters = addToFilters(
				state.checkedFilters,
				action.payload
			);

			// console.log("Checked filters", checkedFilters);

			let taxBills = filterBills(state.taxBills, checkedFilters);

			return {
				...state,
				tempTaxBills: taxBills,
				checkedFilters,
				[action.payload.filter]: alteredArray,
				page:
					taxBills.length / state.rowsPerPage >= state.page
						? state.page
						: 0,
			};
		case 'clear_filter':
			let year = [];
			let type = [];
			let status = [];

			state.yearFilters.forEach((filter) => {
				console.log('FILTER NAME', action.payload.name);

				if (filter.name === action.payload.name) {
					year.push({ ...filter, checked: false });
				} else {
					year.push({ ...filter });
				}
			});

			state.typeFilters.forEach((filter) => {
				console.log('FILTER NAME', filter);

				if (filter.name === action.payload.name) {
					type.push({ ...filter, checked: false });
				} else {
					type.push({ ...filter });
				}
			});

			state.statusFilters.forEach((filter) => {
				console.log('FILTER NAME', filter);

				if (filter.name === action.payload.name) {
					status.push({ ...filter, checked: false });
				} else {
					status.push({ ...filter });
				}
			});

			let newName = () => {
				if (action.payload.name === 'Paid') {
					return 1;
				} else if (action.payload.name === 'Unpaid') {
					return 0;
				}

				return action.payload.name;
			};

			let checked = addToFilters(state.checkedFilters, {
				...action.payload,
				name: newName(),
			});

			let bills = state.taxBills;

			filterBills(bills, checked);

			console.log('CHECKED', checked);

			if (checked.length === 0) {
				console.log('Called Yo');
				return {
					...state,
					tempTaxBills: state.taxBills,
					yearFilters: year,
					typeFilters: type,
					statusFilters: status,
					checkedFilters: checked,
				};
			}

			return {
				...state,
				tempTaxBills: bills,
				yearFilters: year,
				typeFilters: type,
				statusFilters: status,
				checkedFilters: checked,
				page: 0,
			};
		case 'clear_filters':
			let yearFilters = [];
			let typeFilters = [];
			let statusFilters = [];

			for (var i in state.yearFilters) {
				yearFilters.push({ ...state.yearFilters[i], checked: false });
			}
			for (var i in state.typeFilters) {
				typeFilters.push({ ...state.typeFilters[i], checked: false });
			}
			for (var i in state.statusFilters) {
				statusFilters.push({
					...state.statusFilters[i],
					checked: false,
				});
			}
			console.log(yearFilters);
			return {
				...state,
				tempTaxBills: state.taxBills,
				yearFilters,
				typeFilters,
				statusFilters,
				checkedFilters: [],
			};
		default:
			return state;
	}
};

const searchTaxBills = (dispatch) => async (searchText, searchBy, refresh) => {
	// if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
	//   dispatch({
	//     type: "set_tax_bills",
	//     payload: dummyData,
	//   });
	// } else {

	dispatch({
		type: 'searching_tax_bills',
		payload: true,
	});

	localStorage.setItem('searchText', searchText);
	localStorage.setItem('searchBy', searchBy);


	try {
		var responseFirst = await axios({
			method: 'post',
			url: `${baseURL()}`,
			data: qs.stringify({
				method: 'searchTaxBills',
				searchText,
				searchBy
			}),
			withCredentials: true,
		});
		

		if (!responseFirst.data.session) {

			//Due to the session ending we restart it and make the request again
			let opID = localStorage.getItem('opID');

			await axios({
				method: 'post',
				url: `${baseURL()}`,
				data: qs.stringify({
					method: 'hydrateTerminal',
					opID,
				}),
			});

			var responseSecound = await axios({
				method: 'post',
				url: `${baseURL()}`,
				data: qs.stringify({
					method: 'searchTaxBills',
					searchText,
					searchBy
				}),
				withCredentials: true,
			});
		}
		const response = (typeof responseSecound !== "undefined") ? responseSecound : responseFirst;

		console.log('SEARCH TAX BILLS RESPONSE', response);

		// else {
		if (response.data.status === 1) {
			let invoices = response.data.invoices;


			if (response.data.invoices.length >= 1000) {
				alert('Search limited to a 1000 records. Please refine your search.');
			}

			let typeFilters = [
				...new Set(response.data.invoices.map((i) => i.recordType)),
			];
			typeFilters.forEach((f, index) => {
				typeFilters[index] = {
					name: f,
					checked: false,
					filter: 'typeFilters',
					prop: 'reportType',
				};
			});

			let yearFilters = [
				...new Set(response.data.invoices.map((i) => i.taxYear)),
			];
			yearFilters.forEach((f, index) => {
				yearFilters[index] = {
					name: f,
					checked: false,
					filter: 'yearFilters',
					prop: 'taxYear',
				};
			});

			let statusFilters = [
				...new Set(response.data.invoices.map((i) => i.paid)),
			];
			statusFilters.forEach((f, index) => {
				statusFilters[index] = {
					name: f === 1 ? 'Paid' : 'Unpaid',
					checked: false,
					filter: 'statusFilters',
					prop: 'paid',
				};
			});

			invoices.map((invoice, index) => {
				invoice.row = index + 1;
				invoice.balance = parseFloat(invoice.balance);
			});

			console.log('INVOICES', invoices);

			if (invoices.length === 0) {
				alert('No records found. Try another search.');
			}

			dispatch({
				type: 'set_tax_bills',
				payload: {
					invoices,
					yearFilters,
					typeFilters,
					statusFilters,
					searchText,
				},
			});
		} else {
			dispatch({
				type: 'searching_tax_bills',
				payload: false,
			});
			console.log('Something went wrong oh no');
		}
		// }
	} catch (err) {
		console.log(err);
	}
	// }
};

const filterList =
	(dispatch) =>
	({ text, list }) => {
		const newText = text.toLowerCase().replace(/ /g, '');

		let filteredList = list.filter(function (p) {
			return (
				p.name.toLowerCase().replace(/ /g, '').includes(newText) ||
				p.type.toLowerCase().replace(/ /g, '').includes(newText) ||
				p.year
					.toString()
					.toLowerCase()
					.replace(/ /g, '')
					.includes(newText) ||
				p.account
					.toString()
					.toLowerCase()
					.replace(/ /g, '')
					.includes(newText)
			);
		});

		dispatch({
			type: 'set_temp_list',
			payload: filteredList,
		});
	};

const setViewItemVisible = (dispatch) => async (visible) => {
	dispatch({
		type: 'set_view_item_visible',
		payload: visible,
	});
};

const clearResults = (dispatch) => async () => {
	dispatch({
		type: 'clear_invoices',
		payload: true,
	});
};

const setChecked =
	(dispatch) =>
	async ({ name, filter, prop }) => {
		dispatch({
			type: 'set_checked',
			payload: { name, filter, prop },
		});
	};

const saveFilters = (dispatch) => async (filter) => {
	dispatch({
		type: 'save_filters',
		payload: filter,
	});
};

const clearFilters = (dispatch) => async () => {
	dispatch({
		type: 'clear_filters',
	});
};

const clearFilter =
	(dispatch) =>
	async ({ name, filter, prop }) => {
		dispatch({
			type: 'clear_filter',
			payload: { name, filter, prop },
		});
	};

const setPage = (dispatch) => async (page) => {
	dispatch({
		type: 'set_page',
		payload: page,
	});
};

const setRowsPerPage = (dispatch) => async (rows) => {
	dispatch({
		type: 'set_rows_per_page',
		payload: rows,
	});
};

const readTaxBill = (dispatch) => async (id) => {
	console.log('ID', id);
	dispatch({
		type: 'set_loading_read_bill',
	});

	const response = await axios({
		method: 'post',
		url: `${baseURL()}`,
		data: qs.stringify({
			method: 'readTaxBill',
			invoiceID: id,
		}),
		withCredentials: true,
	});

	console.log('READ TAX BILL RESPONSE', response.data);

	if (response.data.status === 1) {
		localStorage.setItem('invoiceID', response.data.invoiceID);
	}

	if (!response.data.session) {
		let opID = localStorage.getItem('opID');

		const hydrateTerminalResponse = await axios({
			method: 'post',
			url: `${baseURL()}`,
			data: qs.stringify({
				method: 'hydrateTerminal',
				opID,
			}),
		});

		const readTaxBillResponse = await axios({
			method: 'post',
			url: `${baseURL()}`,
			data: qs.stringify({
				method: 'readTaxBill',
				invoiceID: id,
			}),
			withCredentials: true,
		});

		console.log(
			'READ TAX BILL REFRESHED RESPONSE',
			readTaxBillResponse.data
		);

		if (response.data.status === 1) {
			localStorage.setItem(
				'invoiceID',
				readTaxBillResponse.data.invoiceID
			);
		}

		dispatch({
			type: 'set_current_bill',
			payload: readTaxBillResponse.data,
		});
	} else {
		dispatch({
			type: 'set_current_bill',
			payload: response.data,
		});
	}
};

export const { Provider, Context } = createDataContext(
	reducer,
	{
		searchTaxBills,
		filterList,
		setViewItemVisible,
		clearResults,
		setChecked,
		saveFilters,
		clearFilter,
		clearFilters,
		setPage,
		setRowsPerPage,
		readTaxBill,
	},
	{
		taxBills: [],
		tempTaxBills: [],
		viewItemVisible: true,
		checkedFilters: [],
		filtersChips: [],
		yearFilters: [],
		typeFilters: [],
		statusFilters: [],
		filters: [],
		page: 0,
		rowsPerPage: 20,
		taxBill: {
			billInfo: {},
			paymentInfo: {},
			taxBreakDown: [{}],
			customTaxBreakDown: [{}],
			caseCharges: [{}],
			propertyDetails: {},
			invoiceID: '',
		},
		loadingReadBill: true,
		searchText: '',
		searchingTaxBills: false,
	}
);
